import React from 'react';
import { withStyles, Theme, createStyles } from '@material-ui/core/styles';
import Switch, { SwitchClassKey, SwitchProps } from '@material-ui/core/Switch';
import { green } from 'globals/colors';

interface Styles extends Partial<Record<SwitchClassKey, string>> {
  focusVisible?: string;
}

interface Props extends SwitchProps {
  classes: Styles;
}

const width = 56;
const height = 32;
const dotSize = 24;

const MediumSwitch = withStyles(({ spacing, palette, transitions }: Theme) =>
  createStyles({
    root: {
      width,
      minWidth: width,
      height,
      padding: 0,
      margin: spacing(1),
      '& .MuiButtonBase-root': {
        backgroundColor: 'transparent',
      },
    },
    switchBase: {
      padding: 1,
      '&$checked': {
        transform: 'translateX(24px)',
        color: palette.common.white,
        '& + $track': {
          backgroundColor: green.MAIN,
          opacity: 1,
          border: 0,
        },
      },
      '&$focusVisible $thumb': {
        color: palette.primary.main,
      },
    },
    thumb: {
      width: dotSize,
      height: dotSize,
      transform: `translateX(4px) translateY(3px)`,
    },
    track: {
      borderRadius: height / 2,
      backgroundColor: palette.grey[200],
      opacity: 1,
      transition: transitions.create(['background-color', 'border']),
    },
    checked: {},
    focusVisible: {},
  })
)(({ classes, ...props }: Props) => {
  return (
    <Switch
      focusVisibleClassName={classes.focusVisible}
      disableRipple
      classes={{
        root: classes.root,
        switchBase: classes.switchBase,
        thumb: classes.thumb,
        track: classes.track,
        checked: classes.checked,
      }}
      {...props}
    />
  );
});

interface FsLargeSwitchProps {
  name?: string;
  onChange?: () => void;
  checked?: boolean;
}

const FsMediumSwitch: React.FC<FsLargeSwitchProps> = ({
  name,
  onChange,
  checked,
}) => {
  return <MediumSwitch checked={checked} onChange={onChange} name={name} />;
};

export default FsMediumSwitch;
